import { Box, IconButton, TextField, Tooltip } from "@mui/material"
import React, { useEffect, useState } from "react"
import Typography from "@mui/material/Typography"
import AddIcon from "@mui/icons-material/Add"
import RemoveIcon from "@mui/icons-material/Remove"

export const NftBox = ({
  title,
  img,
  alt,
  price,
  amount,
  quantity,
  onQuantityChange,
}) => {
  const [qtyInput, setQtyInput] = useState(String(quantity ?? 0))

  useEffect(() => {
    setQtyInput(String(quantity ?? 0))
  }, [quantity])

  const handleIncrement = () => {
    const next = (Number(quantity) || 0) + 1
    onQuantityChange(next)
  }

  const handleDecrement = () => {
    const current = Number(quantity) || 0
    if (current > 0) onQuantityChange(current - 1)
  }

  const handleChange = (event) => {
    const raw = event.target.value

    // Разрешаем “промежуточные” состояния: пусто, 0, 01, 123 и т.д.
    if (/^\d*$/.test(raw)) {
      setQtyInput(raw)
    }
  }

  const commit = () => {
    // Пустое поле трактуем как 0 (можно поменять на возврат к прошлому quantity)
    const next = qtyInput === "" ? 0 : Number.parseInt(qtyInput, 10)

    if (Number.isNaN(next) || next < 0) {
      setQtyInput(String(quantity ?? 0))
      return
    }

    onQuantityChange(next)
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      commit()
      event.currentTarget.blur()
    }
  }

  return (
    <Tooltip arrow title={title}>
      <Box textAlign="center" sx={{ mb: { xss: 4, sm: 4, lg: 0 } }}>
        <Typography
          variant="h4"
          textAlign="center"
          sx={{ fontSize: ".825rem", lineHeight: "2.5", mb: 2 }}
        >
          {title}
        </Typography>

        <Box
          textAlign="center"
          sx={{
            padding: {
              xs: "16px 32px",
              md: "16px 0"
            },
            background:
              "url(https://faraland.io/static/media/circle-highlight.a886adc7.png)",
            backgroundSize: "75%",
            backgroundPosition: "50% 50%",
            backgroundRepeat: "no-repeat",
            "& > img": {
              width: "180px",
            },
          }}
        >
          <img src={img} alt={alt} />
        </Box>

        <Typography variant="body1" gutterBottom>
          Remaining boxes: <span className="primary">{amount}</span>
        </Typography>

        <Typography variant="body1" gutterBottom>
          Price per box: <span className="primary">{price} USDT</span>
        </Typography>

        <Typography variant="body1" mb={2}>
          Select quantity:
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 1,
            mb: 2,
          }}
        >
          <IconButton
            onClick={handleDecrement}
            disabled={quantity <= 0}
            size="small"
            sx={{ border: "1px solid rgba(255, 255, 255, 0.23)" }}
          >
            <RemoveIcon fontSize="small" />
          </IconButton>

          <TextField
            value={qtyInput}
            onChange={handleChange}
            onBlur={commit}
            onKeyDown={handleKeyDown}
            size="small"
            variant="outlined"
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*",
              style: { textAlign: "center", width: "40px" },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "rgba(255, 255, 255, 0.23)",
                },
              },
            }}
          />

          <IconButton
            onClick={handleIncrement}
            size="small"
            sx={{ border: "1px solid rgba(255, 255, 255, 0.23)" }}
          >
            <AddIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>
    </Tooltip>
  )
}
